<template>
  <div>
    <rg-history-menu-button
      :isMobileDevice="isMobileDevice"
      :tooltipSettings="{
        text: '過去履歴表示',
        position: 'right',
      }"
    ></rg-history-menu-button>
  </div>
</template>

<script>
import RgHistoryMenuButton from "./RgHistoryMenuButton.vue";

export default {
  name: "RgHistoryPlayerButton",
  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RgHistoryMenuButton,
  },
};
</script>

<style lang="scss" scoped></style>
